import AScene from '../../library/ExtendedObjects/AScene.js';
import Utils from '../../library/Utils.js';
import BubbleArea from './BubbleArea.js';
import SendArea from './SendArea.js';
import gameData from '../../gameData.js';
import Header from './Header.js';
import LikeEffect from './LikeEffect.js';
import End from '../end/End.js';
import { Localization } from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';

export default class Game extends AScene
{
    static get KEY() { return 'Game'; }
    constructor()
    {
        super({ key: (Game).KEY });
    }

    create()
    {
        this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
          if (event instanceof MouseEvent) {
            this.input.manager.onMouseUp(event);
          }
        });

        this.background = this.createRect(0, 0, this.size.width, this.size.height, 0xF3FFFD);

        this.bubbleDelay = 800;
        this.bubbleArea = new BubbleArea(this, 820);
        this.bubbleArea.sendMessage(true, "An idiom is a word or phrase that means something different from\nits literal meaning.", this.bubbleDelay , ()=>{
            if(this.isDestroyed) return;
            this.bubbleArea.sendMessage(true, "Idioms are common phrases or terms whose meaning is changed, but they can be understood by\ntheir popular use.", this.bubbleDelay , ()=>{
                if(this.isDestroyed) return;
                this.bubbleArea.sendMessage(true, "Learn the idioms by selecting emojis to represent them and then answering questions about the phrases. ", this.bubbleDelay , ()=>{
                    if(this.isDestroyed) return;
                    for(let i = 0; i < this.letsPlay_Text.length; i++)
                    {
                        this.addDelay(i * 80, ()=>{this.addLetter(this.letsPlay_Text[i]);});
                    }
                    this.addDelay(this.letsPlay_Text.length * 80, ()=>{
                        if(this.isDestroyed) return;
                        this.sendArea.toggleCanSend(true);
                    });
                });
            });
        });

        this.header = new Header(this);

        this.letsPlay_Text = ['O','K',' ','I','\'','m',' ','r','e','a','d','y',' ','t','o',' ','p','l','a','y','!'];
        this.sendText = "";
        this.sendArea = new SendArea(this, (text)=>{this.onTextSent(text);}, (images)=>{this.onImageSent(images);}, this.bubbleArea);

        let idiomIndex = ABCyaLib.Storage.getObject("idiomIndex");
        if(idiomIndex == null)
        {
            idiomIndex = Math.round(Math.random()*gameData.groups.length);
        }
        idiomIndex++;
        if(idiomIndex >= gameData.groups.length) idiomIndex = 0;
        ABCyaLib.Storage.saveObject("idiomIndex", idiomIndex.toString());
        
        this.idioms = Utils.Shuffle(gameData.groups[idiomIndex]);
        this.idiomIndex = 0;
        this.currentIdiom = null;

        this.incorrectAttempts = 0;
        this._incorrectIndex = 0;
        this._correctIndex = 0;
        this._incorrectFeedback = Utils.Shuffle(gameData.wrong);
        this._correctFeedback = Utils.Shuffle(gameData.right);

        this.states = {Emoji: "Emoji", Definition: "Definition", Sentence: "Sentence"};
        this.state = null;

        this.likeEffect = new LikeEffect(this);
        this.isDestroyed = false;
    }

    goToEnd()
    {
        let renderTexture = new Phaser.GameObjects.RenderTexture(this, 0, 0, this.size.width, this.size.height);
        renderTexture.draw(this.children);
        renderTexture.saveTexture('game');
        
        this.scene.start(End.KEY);
    }

    beginReviewState()
    {
        this.idiomIndex = 0;
        this.state = this.states.Sentence;
        this.header.beginReviewState();
        this.askSentence();
    }

    addLetter(letter)
    {
        if(this.isDestroyed) return;

        this.playSound("click");

        this.sendText += letter;
        this.sendArea.setText(this.sendText, false);
    }

    onTextSent(text)
    {
        if(this.isDestroyed) return;
        if(text == "") return;

        text = text.replace(/\n/g, " ");

        this.bubbleArea.sendMessage(false, text);
        if(this.state == null)
        {
            
            this.addDelay(300, ()=>{
                this.bubbleArea.sendMessage(true, "Great! Let's get started. Try to match emojis to the following idiom.", this.bubbleDelay, ()=>{
                    this.nextIdiom();
                    this.askEmoji();
                });
            });
        }
        else if(this.state == this.states.Definition)
        {
            if(this.currentIdiom.correct_definition == text)
            {
                this.sendArea.toggleBottom(false);
                this.addDelay(400, ()=>{
                    if(this.idiomIndex >= 6)
                    {
                        this.likeEffect.playEffect();
                        this.bubbleArea.sendMessage(true, "Hold the phone!!! You just finished defining six idioms! Now let's try to figure out what fits into the following sentence:", this.bubbleDelay, ()=>{
                            this.beginReviewState();
                        }, true);
                    }
                    else
                    {
                        this.bubbleArea.sendMessage(true, this.correctFeedback + " Try to match emojis to this next idiom.", this.bubbleDelay, ()=>{
                            this.nextIdiom();
                            this.askEmoji();
                        }, true);
                    }
                });
            }
            else
            {
                this.sendWrongText();
            }
        }
        else if(this.state == this.states.Sentence)
        {
            if(this.currentIdiom.correct_idiom == text)
            {
                this.sendArea.toggleBottom(false);
                this.addDelay(400, ()=>{
                    if(this.idiomIndex >= 6)
                    {
                        this.bubbleArea.sendMessage(true, Localization.instance.getLocalizedString('finalText'), this.bubbleDelay, ()=>{
                            this.bubbleArea.sendMessage(true, "Congratulations on winning!!! You knocked it out of the park!", this.bubbleDelay, ()=>{
                                this.addDelay(1500, ()=>{
                                    this.goToEnd();
                                });
                            });
                        }, true);
                    }
                    else
                    {
                        this.bubbleArea.sendMessage(true, this.correctFeedback + " Now try to pick the correct idiom for the following sentence:", this.bubbleDelay, () => {
                            this.askSentence();
                        }, true);
                    }
                });
            }
            else
            {
                this.sendWrongText(false);
            }
        }
    }

    nextIdiom()
    {
        this.currentIdiom = this.idioms[this.idiomIndex];
        this.idiomIndex++;
        this.header.incrementProgress();
    }

    askEmoji()
    {
        if(this.isDestroyed) return;
        this.state = this.states.Emoji;
        
        this.bubbleArea.sendMessage(true, this.currentIdiom.name, this.bubbleDelay, ()=>{
            this.sendArea.showEmojis(this.currentIdiom.emojis, this.currentIdiom.banned_emojis);
        });
    }

    askDefinition()
    {
        if(this.isDestroyed) return;
        this.state = this.states.Definition;
        this.sendArea.showTexts(this.currentIdiom.correct_definition, this.currentIdiom.incorrect_definitions);
    }

    askSentence()
    {
        if(this.isDestroyed) return;
        this.nextIdiom();
        
        this.bubbleArea.sendMessage(true, this.currentIdiom.sentence, this.bubbleDelay, () => {
            this.sendArea.showTexts(this.currentIdiom.correct_idiom, this.currentIdiom.incorrect_idioms);
        });
    }

    onImageSent(images)
    {
        if(images.length <= 0 || this.isDestroyed) return;

        let correct = true;
        if(images.length != this.currentIdiom.emojis.length) correct = false;
        else
        {
            for(let i = 0; i < images.length; i++)
            {
                if(this.currentIdiom.emojis.indexOf(images[i]) == -1) correct = false;
            }
        }

        if(this.currentIdiom.name == "The cat's meow" && images.indexOf("Speak") == -1 && images.indexOf("Cat") != -1 && images.length == 1) correct = true; //Catch for one-off

        this.bubbleArea.sendImages(false, images);

        if(correct)
        {
            this.sendArea.toggleBottom(false);
            this.addDelay(400, ()=>{
                this.bubbleArea.sendMessage(true, this.correctFeedback + " Now, what does the idiom mean?", this.bubbleDelay, ()=>{
                    this.askDefinition();
                }, true);
            }); 
        }
        else
        {
            this.sendWrongText();
        }
    }

    sendWrongText(isIdiom = true)
    {
        this.addDelay(400, ()=>{this.bubbleArea.sendMessage(true, this.incorrectFeedback, this.bubbleDelay, ()=>{
            this.incorrectAttempts++;
            if(this.incorrectAttempts > 2){
                this.incorrectAttempts = 0;
                if(isIdiom) this.bubbleArea.sendMessage(true, "Remember the idiom is:\n" + this.currentIdiom.name, 400); 
                else this.bubbleArea.sendMessage(true, "Remember the sentence is:\n" + this.currentIdiom.sentence, 400); 
            }
        }, false);}); 
    }

    get correctFeedback()
    {
        this._correctIndex++;
        if(this._correctIndex >= this._correctFeedback.length) this._correctIndex = 0;
        return this._correctFeedback[this._correctIndex];
    }

    get incorrectFeedback()
    {
        this._incorrectIndex++;
        if(this._incorrectIndex >= this._incorrectFeedback.length) this._incorrectIndex = 0;
        return this._incorrectFeedback[this._incorrectIndex];
    }

    update(time, delta)
    {
        if(this.isDestroyed) return;

        this.likeEffect.update(delta);
        this.bubbleArea.update();
        this.sendArea.update();
    }
}